// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__d3IEH"};